/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import PreSurgerySurveyFilledJournalEvent from "parog-web/models/pre-surgery-survey-filled-journal-event";
import emberSwal from "ui-kit/utils/ember-swal";
import CtcaeCustomBaseEditionForm from "../base-edition-form/edition-form";

export default class PreSurgeryEditionForm extends CtcaeCustomBaseEditionForm {
  static forcDisplayName = "Questionnaire pré-opératoire";
  static fullComponentId = "pre-surgery/edition-form";

  static journalEventClass = PreSurgerySurveyFilledJournalEvent;

  get currentSections(): Array<string> {
    return PreSurgerySurveyFilledJournalEvent.sections;
  }

  @action
  async save(): Promise<PreSurgerySurveyFilledJournalEvent> {
    const je = await super.save();

    let text: string;
    let icon: "info" | "success" | "warning";
    if (je.score >= 100) {
      text =
        "Merci de rappeler immédiatement l'infirmière de coordination de l'Unité de Chirurgie Ambulatoire au 05.31.15.53.70.<br/>En dehors des heures d'ouverture de l'unité (9h à 16h30, vous serez mis en relation avec l'interne de garde au même numéro.";
      icon = "warning";
    } else if (je.score >= 10) {
      text =
        "Merci de reprendre les consignes données par l'anesthésiste pour le traitement médicamenteux.<br/>Vous recevrez un message la veille de votre intervention vous indiquant l’heure de convocation.<br/>Bonne journée.";
      icon = "info";
    } else {
      text =
        "Merci pour vos réponses. Nous ne relevons pas de problèmes notables.<br/>Vous recevrez un message la veille de votre intervention vous indiquant l’heure de convocation.<br/>Bonne journée.";
      icon = "success";
    }
    await emberSwal.fire({
      html: text,
      icon,
      confirmButtonText: "Message lu",
      confirmButtonColor: "#FC1369"
    });

    return je;
  }
}
